import '@backstage/cli/asset-types';
import '@backstage/ui/css/styles.css';
import './index.css';
import ReactDOM from 'react-dom/client';
import app from './App';

ReactDOM.createRoot(document.getElementById('root')!).render(app);
